<section id="chartist-pie-charts">
  <div class="row">

    <div class="col-xl-3 col-lg-6 col-md-12">
      <div class="card">
        <div class="card-header">
          <p class="darken-2 card-title">Total Gymers</p>
          <h3 class="display-4 blue-grey lighten-2 text-center pt-1">{{gymersValue}}</h3>
        </div>
          <div class="card-content collapse show text-center">
              <div class="card-body">
                  <app-pie-chart [data]="[{value:'\ue9d7'}]" [loadingData]="loadingData"
                        [id]="'donut-gradient-chart1'" [color]="'105,103,206'" [style]="'donutGradient2'" [fontFamily]="'feather'">

                        <ul class="list-inline clearfix mt-2">
                          <li>
                            <h1 class="blue-grey lighten-2 text-bold-400">{{gymers7Days}}</h1>
                            <span class="darken-2">
                                <i class="ft-user"></i> Last 7 days</span>
                          </li>
                      </ul>
                  </app-pie-chart>
              </div>
          </div>
      </div>
    </div>

    <div class="col-xl-3 col-lg-6 col-md-12">
        <div class="card">
            <div class="card-header">
              <p class="darken-2 card-title">Total Coachs</p>
              <h3 class="display-4 blue-grey lighten-2 text-center pt-1">{{coachesValue}}</h3>
            </div>
            <div class="card-content collapse show text-center">
              <div class="card-body">
                <app-pie-chart [data]="[{value:'\ue9d7'}]" [loadingData]="loadingData"
                    [id]="'donut-gradient-chart2'" [color]="'25,175,208'" [style]="'donutGradient3'" [fontFamily]="'feather'">

                    <ul class="list-inline clearfix mt-2">
                      <li>
                        <h1 class="blue-grey lighten-2 text-bold-400">{{coaches7Days}}</h1>
                        <span class="darken-2">
                            <i class="ft-user"></i> Posts last 7 days</span>
                      </li>
                  </ul>
                </app-pie-chart>
              </div>
            </div>
        </div>
    </div>

    <div class="col-xl-3 col-lg-6 col-md-12">
        <div class="card">
          <div class="card-header">
            <p class="darken-2 card-title">Total Gyms</p>
            <h3 class="display-4 blue-grey lighten-2 text-center pt-1">{{gymsValue}}</h3>
          </div>
            <div class="card-content collapse show text-center">
                <div class="card-body">
                    <app-pie-chart [data]="[{value:'\ue9d7'}]"
                        [loadingData]="loadingData"
                        [id]="'donut-gradient-chart'" [color]="'253,99,107'" [style]="'donutGradient1'" [fontFamily]="'feather'">

                        <ul class="list-inline clearfix mt-2">
                          <li>
                            <h1 class="blue-grey lighten-2 text-bold-400">{{gyms7Days}}</h1>
                            <span class="darken-2">
                                <i class="ft-user"></i> Last 7 days</span>
                          </li>
                      </ul>
                    </app-pie-chart>
                </div>
            </div>
        </div>
    </div>

    <div class="col-xl-3 col-lg-6 col-md-12">
        <div class="card">
          <div class="card-header">
            <p class="darken-2 card-title">Total Shops</p>
            <h3 class="display-4 blue-grey lighten-2 text-center pt-1">{{shopsValue}}</h3>
          </div>
            <div class="card-content collapse show text-center">
                <div class="card-body">
                    <app-pie-chart [data]="[{value:'\ue9d7'}]" [loadingData]="loadingData"
                        [id]="'donut-gradient-chart2'" [color]="'25,175,208'" [style]="'donutGradient3'" [fontFamily]="'feather'">

                        <ul class="list-inline clearfix mt-2">
                          <li>
                            <h1 class="blue-grey lighten-2 text-bold-400">{{shops7Days}}</h1>
                            <span class="darken-2">
                                <i class="ft-user"></i> Last 7 days</span>
                          </li>
                      </ul>
                    </app-pie-chart>
                </div>
            </div>
        </div>
    </div>
  </div>


  <div class="row">

    <div class="col-xl-3 col-lg-6 col-md-12">
        <div class="card">
          <div class="card-header">
            <p class="darken-2 card-title">Total Posts</p>
            <h3 class="display-4 blue-grey lighten-2 text-center pt-1">{{postsValue}}</h3>
          </div>
            <div class="card-content collapse show text-center">
                <div class="card-body">
                    <app-pie-chart [data]="[{value:'\ue9d7'}]"
                        [loadingData]="loadingData"
                        [id]="'donut-gradient-chart'" [color]="'253,99,107'" [style]="'donutGradient1'" [fontFamily]="'feather'">

                        <ul class="list-inline clearfix mt-2">
                          <li>
                            <h1 class="blue-grey lighten-2 text-bold-400">{{posts7Days}}</h1>
                            <span class="darken-2">
                                <i class="ft-user"></i> Last 7 days</span>
                          </li>
                      </ul>
                    </app-pie-chart>
                </div>
            </div>
        </div>
    </div>

    <div class="col-xl-3 col-lg-6 col-md-12">
        <div class="card">
          <div class="card-header">
            <p class="darken-2 card-title">Total Groups</p>
            <h3 class="display-4 blue-grey lighten-2 text-center pt-1">{{groupsValue}}</h3>
          </div>
            <div class="card-content collapse show text-center">
                <div class="card-body">
                    <app-pie-chart [data]="[{value:'\ue9d7'}]" [loadingData]="loadingData"
                        [id]="'donut-gradient-chart2'" [color]="'25,175,208'" [style]="'donutGradient3'" [fontFamily]="'feather'">

                        <ul class="list-inline clearfix mt-2">
                          <li>
                            <h1 class="blue-grey lighten-2 text-bold-400">{{groups7Days}}</h1>
                            <span class="darken-2">
                                <i class="ft-user"></i> Last 7 days</span>
                          </li>
                      </ul>
                    </app-pie-chart>
                </div>
            </div>
        </div>
    </div>
  </div>

</section>
